// extracted by mini-css-extract-plugin
export default {"mainContainer":"AboutBanner_mainContainer__ivdh9","contentContainer":"AboutBanner_contentContainer__C-EDB","title":"AboutBanner_title__BEg4Y","icon":"AboutBanner_icon__IOiNf"};